module.exports = __webpack_public_path__ + "media/images/pc/stores/hamamatsu/hamamatsu_concept_02-01848f4bcc4bec15679e1850741370a0.jpg";